import {getQuotePriceWithDiscounts, getTotalPrice, toFixedPrice} from "../../misc/helpers";

export const getSubTotalPrice = (discountSections, discountSection, discount, withoutCurrent = false) => {
  const totalPrice = getTotalPrice(null, false);

  let ignoreDiscounts = discountSection.discounts.filter(currentDiscount => {
    return withoutCurrent
      ? currentDiscount.order >= discount.order
      : currentDiscount.order > discount.order
  });
  discountSections.forEach(disSection => {
    if (disSection.order > discountSection.order) {
      ignoreDiscounts = [...ignoreDiscounts, ...disSection.discounts] // ignore other sections
    }
  })

  const grandTotal = getQuotePriceWithDiscounts(totalPrice, ignoreDiscounts);
  return toFixedPrice(grandTotal);
};
